// Menu Coordination Script - Handles interaction between mega menu and search menu
document.addEventListener("DOMContentLoaded", function () {
    // Get both menus and specific elements
    const megaMenu = document.querySelector(".mega-menu");
    const searchMenu = document.querySelector(".search-menu");
    const searchButton = document.querySelector(".mega-menu__button--search");
    const backButton = document.querySelector(".mega-menu__button--back");
    const megaMenuContainer = document.querySelector(".mega-menu__container");
    const megaMenuFooter = document.querySelector(".mega-menu__footer");
    const megaMenuHeader = document.querySelector(".mega-menu__header");
    
    // Check if mobile
    const isMobile = () => window.innerWidth <= 1024;
    
    // Animation settings
    const SLIDE_DURATION = 0.6;
    const SLIDE_EASE = "power2.out";
    
    if (!megaMenu || !searchMenu || !searchButton || !megaMenuContainer || !megaMenuFooter) {
      console.warn("Menu coordination elements not found");
      return;
    }
    
    // Track state
    let isTransitioning = false;
    let cameFromMegaMenu = false;
    
    // Function to show back button for search mode
    function showSearchBackButton() {
      if (!isMobile() || !backButton) return;
      
      // Set navigation mode to search
      backButton.setAttribute('data-navigation-mode', 'search');
      
      // Hide search button and show back button
      gsap.to(searchButton, {
        x: -30,
        opacity: 0,
        duration: SLIDE_DURATION,
        ease: "power2.in",
        onComplete: () => {
          gsap.set(searchButton, { visibility: "hidden" });
          
          // Show back button
          gsap.to(backButton, {
            x: 0,
            opacity: 1,
            visibility: "visible",
            duration: SLIDE_DURATION,
            ease: SLIDE_EASE,
          });
        }
      });
    }
    
    // Function to hide back button and show search button
    function hideSearchBackButton() {
      if (!isMobile() || !backButton) return;
      
      // Hide back button
      gsap.to(backButton, {
        x: 20,
        opacity: 0,
        duration: 0.4,
        ease: "power2.in",
        onComplete: () => {
          gsap.set(backButton, { visibility: "hidden" });
          
          // Reset navigation mode
          backButton.setAttribute('data-navigation-mode', 'mega-menu');
          
          // Show search button
          gsap.to(searchButton, {
            x: 0,
            opacity: 1,
            visibility: "visible",
            duration: SLIDE_DURATION,
            ease: SLIDE_EASE,
          });
        },
      });
    }
    
    // Override the search button click handler
    searchButton.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (!isMobile()) {
        // Desktop - just trigger the search menu normally
        if (window.searchMenuFunctions && window.searchMenuFunctions.openMenu) {
          window.searchMenuFunctions.openMenu();
        }
        return;
      }
      
      // Mobile - check if search menu is already open
      const isSearchMenuOpen = document.body.classList.contains("search-menu-open");
      if (isSearchMenuOpen) {
        //console.log("Search menu already open, ignoring click");
        return;
      }
      
      // Mobile - coordinate the slide animation
      handleMobileSearchTransition();
    }, true); // Use capture phase
    
    function handleMobileSearchTransition() {
      // Check if mega menu is open
      const isMegaMenuOpen = document.body.classList.contains("mega-menu-open");
      
      if (!isMegaMenuOpen || isTransitioning) return;
      
      //console.log("Starting mobile search transition");
      
      // Ensure search menu is in correct position before starting
      gsap.set(searchMenu, {
        left: "100%",
        top: "100px", // Keep at 100px for mobile slide animation
        visibility: "visible"
      });
      
      isTransitioning = true;
      cameFromMegaMenu = true;
      
      // Show the back button for search mode
      showSearchBackButton();
      
      // Create a timeline for the coordinated transition
      const transitionTimeline = gsap.timeline({
        onComplete: () => {
          isTransitioning = false;
          // Ensure search menu is marked as open
          document.body.classList.add("search-menu-open");
        }
      });
      
      // Simultaneously: slide mega menu container out left AND search menu in from right
      transitionTimeline
        .to([megaMenuContainer, megaMenuFooter], {
          x: "-100%",
          duration: SLIDE_DURATION,
          ease: "power2.inOut",
          stagger: 0
        })
        .to(searchMenu, {
          left: "0%",
          duration: SLIDE_DURATION,
          ease: "power2.inOut"
        }, 0) // Start at the same time (0 offset)
        .to(megaMenuHeader, {
          backgroundColor: "#F3F1EB",
          duration: SLIDE_DURATION,
          ease: "power2.inOut"
        }, 0) // Start at the same time as the slide animations
        .to(".mega-menu__header .mega-menu__button", {
          backgroundColor: "#FFFFFF",
          duration: SLIDE_DURATION,
          ease: "power2.inOut"
        }, 0); // Start at the same time as header transition
    }
    
    // Function to handle returning from search to mega menu
    function returnToMegaMenu() {
      if (!isMobile() || !cameFromMegaMenu || isTransitioning) return;
      
      //console.log("Returning to mega menu");
      
      isTransitioning = true;
      
      // Create a timeline for the coordinated reverse animation
      const returnTimeline = gsap.timeline({
        onComplete: () => {
          isTransitioning = false;
          cameFromMegaMenu = false;
          // Reset search menu classes
          document.body.classList.remove("search-menu-open");
          // Reset back button
          if (backButton) {
            backButton.setAttribute('data-navigation-mode', 'mega-menu');
          }
        }
      });
      
      // Simultaneously: slide search menu out right AND mega menu container back in from left
      returnTimeline
        .to(searchMenu, {
          left: "100%",
          duration: SLIDE_DURATION,
          ease: "power2.inOut"
        })
        .to([megaMenuContainer, megaMenuFooter], {
          x: "0%",
          duration: SLIDE_DURATION,
          ease: "power2.inOut",
          stagger: 0
        }, 0) // Start at the same time (0 offset)
        .to(megaMenuHeader, {
          backgroundColor: "transparent", // Return to mega menu's original background
          duration: SLIDE_DURATION,
          ease: "power2.inOut"
        }, 0) // Start at the same time as the slide animations
        .to(".mega-menu__header .mega-menu__button", {
          backgroundColor: "#F3F1EB", // Return buttons to original background
          duration: SLIDE_DURATION,
          ease: "power2.inOut"
        }, 0) // Start at the same time as header transition
        .call(() => {
          // Make sure mega menu is still marked as open
          if (!document.body.classList.contains("mega-menu-open")) {
            document.body.classList.add("mega-menu-open");
          }
          
          // Hide the search back button and show search button
          hideSearchBackButton();
        }, null, 0.2); // Call this slightly after the animation starts
    }
    
    // Handle back button click
    if (backButton) {
      backButton.addEventListener("click", function(e) {
        if (!isMobile()) return;
        
        //console.log("Back button clicked");
        
        // Check navigation mode
        const navigationMode = backButton.getAttribute('data-navigation-mode');
        //console.log("Navigation mode:", navigationMode);
        //console.log("Came from mega menu:", cameFromMegaMenu);
        
        if (navigationMode === 'search' && cameFromMegaMenu) {
          e.preventDefault();
          e.stopPropagation();
          //console.log("Triggering return to mega menu");
          returnToMegaMenu();
        }
        // Otherwise, let the mega menu handler take care of it
      }, true); // Use capture phase to ensure we get the event first
    }
    
    // Handle search menu close to return to mega menu
    const searchCloseButton = document.querySelector(".search-menu__button--close");
    const searchBackButton = document.querySelector(".search-menu__button--back");
    
    if (searchCloseButton) {
      // Monitor search menu close events
      searchCloseButton.addEventListener("click", function(e) {
        if (!isMobile()) return;
        
        // Check if we came from mega menu
        if (cameFromMegaMenu && document.body.classList.contains("search-menu-open")) {
          e.preventDefault();
          e.stopPropagation();
          returnToMegaMenu();
        } else {
          // Normal close - reset the flag
          setTimeout(() => {
            cameFromMegaMenu = false;
          }, 100);
        }
      }, true);
    }
    
    // Also handle back button on search menu
    if (searchBackButton) {
      searchBackButton.addEventListener("click", function(e) {
        if (!isMobile()) return;
        
        // Check if we came from mega menu
        if (cameFromMegaMenu) {
          e.preventDefault();
          e.stopPropagation();
          returnToMegaMenu();
        }
      });
    }
    
    // Handle close text if it exists
    const searchCloseText = document.querySelector(".search-menu__close-text");
    if (searchCloseText) {
      searchCloseText.addEventListener("click", function(e) {
        if (!isMobile() || !cameFromMegaMenu) return;
        
        e.preventDefault();
        e.stopPropagation();
        returnToMegaMenu();
      });
    }
    
    // Monitor when search menu actually closes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target === document.body) {
            const hasSearchMenuOpen = target.classList.contains('search-menu-open');
            if (!hasSearchMenuOpen && !target.classList.contains('mega-menu-open')) {
              // Search menu closed and mega menu not open - reset flag
              cameFromMegaMenu = false;
            }
          }
        }
      });
    });
    
    // Start observing body class changes
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Handle mega menu close button when search menu is open
    const megaMenuCloseButton = document.querySelector(".mega-menu__button--close");
    if (megaMenuCloseButton) {
      megaMenuCloseButton.addEventListener("click", function(e) {
        //console.log("Mega menu close button clicked");
        
        // Check if search menu is open and we came from mega menu
        const isSearchMenuOpen = document.body.classList.contains("search-menu-open");
        
        if (isSearchMenuOpen && cameFromMegaMenu && isMobile()) {
          //console.log("Closing both menus from search state");
          e.preventDefault();
          e.stopPropagation();
          
          // Close both menus with coordinated animation
          closeBothMenus();
        }
        // Otherwise let the normal mega menu close handler take care of it
      }, true); // Use capture phase
    }
    
     // Function to close both menus with slide up animation (when closing from search menu)
     function closeBothMenus() {
       if (isTransitioning) return;
       
       //console.log("Closing both menus with slide up animation");
       isTransitioning = true;
       
       // Create timeline for sliding both menus up
       const closeBothTimeline = gsap.timeline({
         onComplete: () => {
           //console.log("Both menus slide up complete - resetting all states");
           
           // Reset all states
           isTransitioning = false;
           cameFromMegaMenu = false;
           
           // Remove all menu classes
           document.body.classList.remove("search-menu-open", "mega-menu-open");
           
           // Reset mega menu button
           const megaMenuButton = document.querySelector(".mega-menu__button");
           if (megaMenuButton) {
             megaMenuButton.classList.remove("active");
           }
           
           // Reset search menu button  
           const searchMenuButton = document.querySelector(".search-menu__button");
           if (searchMenuButton) {
             searchMenuButton.classList.remove("active");
           }
           
           // Reset back button
           if (backButton) {
             backButton.setAttribute('data-navigation-mode', 'mega-menu');
           }
           
           // CRITICAL: Reset mega menu container positions that were moved during coordination
           gsap.set([megaMenuContainer, megaMenuFooter], {
             x: "0%",
             clearProps: "transform"
           });
           
           // Reset search menu to initial state first
           if (window.searchMenuFunctions && window.searchMenuFunctions.resetMenuState) {
             window.searchMenuFunctions.resetMenuState();
           }
           
           // CRITICAL: Reset mega menu timeline and state properly
           setTimeout(() => {
             //console.log("Resetting mega menu after slide up animation");
             
             // Reset mega menu to initial state - this is crucial for reopening
             if (window.megaMenuFunctions && window.megaMenuFunctions.resetMenuState) {
               window.megaMenuFunctions.resetMenuState();
             }
             
             // Also manually reset the menu timeline to ensure it can play again
             const megaMenuButton = document.querySelector(".mega-menu__button");
             if (megaMenuButton && window.megaMenuTimeline) {
               //console.log("Manually resetting mega menu timeline");
               window.megaMenuTimeline.progress(0).pause();
             }
             
             //console.log("All states reset - mega menu should be ready to open again");
           }, 50); // Small delay to ensure slide animation completes first
         }
       });
       
       // Get the mega menu element for sliding up
       const megaMenuElement = document.querySelector(".mega-menu");
       
       // Slide both menus up simultaneously and reset header background
       closeBothTimeline.to([searchMenu, megaMenuElement], {
         top: "-130dvh",
         duration: SLIDE_DURATION * 2,
         ease: "power2.inOut",
         stagger: 0 // No stagger, both slide up together
       })
       .to(megaMenuHeader, {
         backgroundColor: "transparent", // Reset header background
         duration: SLIDE_DURATION * 2,
         ease: "power2.inOut"
       }, 0) // Start at the same time as the slide up
       .to(".mega-menu__header .mega-menu__button", {
         backgroundColor: "#F3F1EB", // Reset buttons to original background
         duration: SLIDE_DURATION * 2,
         ease: "power2.inOut"
       }, 0); // Start at the same time as header reset
       
       // Hide search back button and show search button during the animation
       closeBothTimeline.call(() => {
         hideSearchBackButton();
       }, null, 0.1);
     }

    // Reset state if window is resized
    window.addEventListener("resize", function() {
      if (!isMobile()) {
        // Reset any mobile-specific transforms on desktop
        gsap.set([megaMenuContainer, megaMenuFooter], {
          x: "0%",
          clearProps: "transform"
        });
        cameFromMegaMenu = false;
        
        // Reset back button state
        if (backButton) {
          backButton.setAttribute('data-navigation-mode', 'mega-menu');
        }
      }
    });
  });